export default {
    path: 'information',
    component: () => import(/* webpackChunkName: "common-list" */ '@/pages/Infomation/InfomationList'),
    meta: {title:'账号信息'}
}